import cloneDeep from "lodash/fp/cloneDeep";

class Controller {
  constructor($stateParams, $location, Universal, UniversalTransforms) {
    "ngInject";

    this.$location = $location;
    this.Universal = Universal;
    this.$stateParams = $stateParams;
    this.UniversalTransforms = UniversalTransforms;
  }
  $onInit() {
    this.onSearch = (query) => {
      if (query) {
        const params = { query, limit: 50 };
        delete this.result;

        this.$location.search(params);
        if (!this.searchQuery) this.searchQuery = this.$stateParams.query;

        this.Universal.search(params).$promise.then((response) => {
          this.keyword = cloneDeep(query);
          this.result = this.UniversalTransforms.justify(response.hits);
        });
      }
    };
    this.onSearch(this.$stateParams.query);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/universal/universal.controller.js